module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.01469 3.20407C8.22715 3.41652 8.2923 3.73527 8.18027 4.01406C7.90297 4.70408 7.75 5.45828 7.75 6.25004C7.75 9.56375 10.4363 12.25 13.75 12.25C14.5418 12.25 15.296 12.0971 15.986 11.8198C16.2648 11.7077 16.5835 11.7729 16.796 11.9853C17.0084 12.1978 17.0736 12.5166 16.9615 12.7953C15.8538 15.5518 13.1553 17.5 10 17.5C5.85786 17.5 2.5 14.1422 2.5 10C2.5 6.8447 4.44828 4.14621 7.20469 3.03849C7.48348 2.92645 7.80223 2.99161 8.01469 3.20407ZM6.31418 5.26507C4.90525 6.36347 4 8.07656 4 10C4 13.3137 6.68629 16 10 16C11.9235 16 13.6366 15.0948 14.735 13.6859C14.4125 13.7282 14.0837 13.75 13.75 13.75C9.60786 13.75 6.25 10.3922 6.25 6.25004C6.25 5.91636 6.27184 5.58757 6.31418 5.26507Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
